module.exports = __webpack_public_path__ + "img/compress.c5fefc2d.svg";